<template>
  <div class="tabCon-wrap">
    <div class="tabCon-left">
      <div class="title">
        <span>{{ tabMeunData && tabMeunData.blockName }}</span>
        <p></p>
      </div>
      <div class="tabCon-container">
        <router-link class="tabCon-item" v-for="item in newExternalFirstContentInfoList" :key="item.id" tag="div"
          :to="{ name: 'announcementDetail', params: { blockName: tabMeunData && tabMeunData.blockName, id: item.id } }">
          <div class="tabCon-item-left">
            <p class="time-top">{{ handleDate(item.publishTime)[2] }}</p>
            <p class="time-bottom">{{ handleDate(item.publishTime)[0] }}-{{ handleDate(item.publishTime)[1] }}</p>
          </div>
          <div class="tabCon-item-right">
            <div>
              <h6>{{ item.contentTitle }} </h6>
              <span>NEW</span>
            </div>
            <p>{{ item.content }}</p>
            <router-link
              :to="{ name: 'announcementDetail', params: { blockName: tabMeunData && tabMeunData.blockName, id: item.id } }"
              class="more">了解更多</router-link>
          </div>
        </router-link>
      </div>
      <el-pagination background layout="prev, pager, next" :total="tabMeunData && tabMeunData.total"
        @current-change="handleCurrenChange">
      </el-pagination>
    </div>
    <div class="tabCon-right">
      <img src="@/assets/images/info1.png" alt="">
      <img src="@/assets/images/info2.png" alt="">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data () {
    return {
      start: 0,
      end: 10
    };
  },
  computed: {
    ...mapState(['tabMeunData']),
    newExternalFirstContentInfoList () {
      return this.tabMeunData && this.tabMeunData.externalFirstContentInfoList && this.tabMeunData.externalFirstContentInfoList.slice(this.start, this.end);
    }
  },
  methods: {
    handleCurrenChange (index) {
      if (index === 1) {
        this.start = 0;
        this.end = 10;
      } else {
        this.start = 10 * index - 10;
        this.end = this.start + 10;
      }
    },
    handleDate (date) {
      return date.split(' ')[0].split('-');
    }
  }
};
</script>

<style lang="scss" scoped>
.tabCon-wrap {
  @include container(1200px);
  display: flex;
  justify-content: space-between;
  padding-bottom: 40px;

  .tabCon-left {
    width: 836px;

    .title {
      display: flex;
      align-items: center;
      margin: 30px 0;

      span {
        font-size: 24px;
        color: $el-main-color;
        margin-right: 70px;
      }

      p {
        flex: 1;
        height: 2px;
        background: $el-main-color !important;
      }
    }

    .tabCon-container {
      border-bottom: 1px solid #d3d3d3;
      margin-bottom: 40px;

      .tabCon-item {
        width: 100%;
        height: 200px;
        border-top: 1px solid #d3d3d3;
        display: flex;
        cursor: pointer;

        &:hover {
          border-bottom: 0;
          box-shadow: 0 6px 21px 0 rgba(28, 87, 222, .53);

          // margin-bottom: 20px;
          .tabCon-item-right {
            div {
              h6 {
                color: $el-main-color;
              }
            }
          }
        }

        .tabCon-item-left {
          width: 120px;
          height: 120px;
          border-radius: 15px;
          border: 1px solid #ff8b00;
          text-align: center;
          color: #ff8b00;
          margin: 33px;

          .time-top {
            margin: 0;
            padding: 22px 0 16px;
            font-size: 60px;
            line-height: 42px;
            font-weight: 700;
          }

          .time-bottom {
            margin: 0;
            border-top: 1px solid #ff8b00;
            font-size: 18px;
            line-height: 32px;
          }
        }

        .tabCon-item-right {
          width: calc(100% - 186px);
          padding-top: 40px;
          padding-right: 28px;
          position: relative;

          div {
            display: flex;

            h6 {
              font-size: 20px;
              font-weight: 700;
              color: #1c1c1c;
              line-height: 24px;
              width: 570px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }

            span {
              background-color: #fff4e2;
              font-size: 12px;
              color: #fca61c;
              border-radius: 20px;
              display: flex;
              line-height: 24px;
              padding: 0 8px;
            }
          }

          p {
            padding-top: 20px;
            color: #5c5f6a;
            font-size: 14px;
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .more {
            position: absolute;
            right: 28px;
            bottom: 18px;
            width: 120px;
            height: 36px;
            line-height: 34px;
            border: 1px solid #ccc;
            border-radius: 16px;
            text-align: center;
            color: #1c1c2c;
            font-size: 16px;
          }
        }
      }
    }
  }

  .tabCon-right {
    width: 340px;
    margin-top: 91px;

    img {
      width: 100%;
      margin-bottom: 20px;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/pages/announcementList.vue